module.exports = __webpack_public_path__ + "static/media/wishlist-empty.d32d482b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/cart/wishlist-empty.png
// module id = 635
// module chunks = 0